// removed by extract-text-webpack-plugin
module.exports = {"wallet":"c-Wallet__wallet"};


//////////////////
// WEBPACK FOOTER
// ./src/components/container/Wallet/Wallet.scss
// module id = 566
// module chunks = 0